import React, { useCallback, useRef, useState } from 'react';
import { Upload, X, ImageIcon } from 'lucide-react';

const ImageDropzone = ({ value, onChange }) => {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);

  const handleFile = useCallback((file) => {
    if (!file) return;
    if (!file.type.startsWith('image/')) return;
    const url = URL.createObjectURL(file);
    onChange({ file, preview: url });
  }, [onChange]);

  const onDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    handleFile(e.dataTransfer.files?.[0]);
  };

  if (value?.preview) {
    return (
      <div className="relative w-full aspect-square rounded-2xl overflow-hidden border border-white/10 bg-white/5">
        <img src={value.preview} alt="logo preview" className="w-full h-full object-cover" />
        <button
          type="button"
          data-testid="remove-image-btn"
          onClick={() => onChange(null)}
          className="absolute top-2 right-2 bg-black/60 backdrop-blur-md hover:bg-[#FF6B7A] text-white rounded-full p-1.5 transition-colors">
          <X className="w-4 h-4" />
        </button>
      </div>
    );
  }

  return (
    <div
      data-testid="image-dropzone"
      onClick={() => inputRef.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
      onDragLeave={() => setDragging(false)}
      onDrop={onDrop}
      className={`w-full aspect-square cursor-pointer rounded-2xl border border-dashed transition-all flex flex-col items-center justify-center gap-3 text-center px-4 ${
        dragging
          ? 'border-[#7DF9FF] bg-[#7DF9FF]/10 scale-[1.02]'
          : 'border-white/15 bg-white/[0.03] hover:border-[#7DF9FF]/40 hover:bg-white/[0.05]'
      }`}
    >
      <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#7DF9FF]/20 to-[#A78BFA]/20 flex items-center justify-center">
        <ImageIcon className="w-6 h-6 text-[#7DF9FF]" />
      </div>
      <p className="text-sm font-display font-medium">
        Drop your logo here
      </p>
      <p className="text-xs text-forge-muted">PNG · JPG · WEBP · 5MB</p>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        data-testid="image-file-input"
        onChange={(e) => handleFile(e.target.files?.[0])}
      />
    </div>
  );
};

export default ImageDropzone;
